import { config } from '../config';
import { getHeaders } from './getHeaders';

export const getQuote = (opportunityId: string) =>
  fetch(`${config.apiBaseUrl}/api/v2/opportunities/${opportunityId}/quote`, {
    headers: getHeaders(),
  });
